import { render, staticRenderFns } from "./org-period-company.vue?vue&type=template&id=3ac34324&"
import script from "./org-period-company.vue?vue&type=script&lang=js&"
export * from "./org-period-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports